import * as z from "zod";

export const requiredSelectValue = z
  .string({
    required_error: "Please select a value",
    invalid_type_error: "Please select a value",
  })
  .min(1, "Please select a value");

export const requiredNumberField = (schema: z.ZodNumber) =>
  z.preprocess(
    (value) => {
      if (value === null || value === "" || typeof value === "undefined") {
        return undefined;
      }

      if (typeof value === "number" && Number.isNaN(value)) {
        return undefined;
      }

      return value;
    },
    schema
  );
